import { useSnackbar } from 'notistack';
import { useState } from 'react';
// @mui
import {
  Typography,
  Paper,
  Stack,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { JobPostDoneCard } from "../../";
import {
  AskingWhyFindCrewDialog,
  DIOManagerCallDialog,
} from '../';
// hooks
import useAuth from '../../../../hooks/useAuth';
import useResponsive from '../../../../hooks/useResponsive';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
import DIOText from '../../../../components/DIOText';
// util
import axios from '../../../../utils/axios';


export default function ReviewRequestForm({ jobPost, toggleDialog }) {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');
  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmit, setIsSubmit] = useState(false);
  const [isOpenAskingWhyFindCrew, setIsOpenAskingWhyFindCrew] = useState(false);
  const [isDIOManagerCallDialogOpen, setIsDIOManagerCallDialogOpen] = useState(false);

  const submit = async () => {
    setIsSubmit(true);
    const companyId = user?.employee.company[0].id;
    try {
      const jobPostId = jobPost.id;
      const response = await axios.post(`/api/company/${companyId}/job-posts/${jobPostId}/review-request/`);
      if (smUp) {
        enqueueSnackbar('저장되었습니다');
      } else {
        enqueueSnackbar('저장되었습니다', {anchorOrigin: { vertical: 'bottom', horizontal: 'center' }});
      }
      if (user?.employee.company[0].need_card && !user?.employee.company[0].save_card) {
        setIsDIOManagerCallDialogOpen(true);
      } else {
        toggleDialog(jobPost?.id);
      }
      if (isMountedRef.current) {
        setIsSubmit(false);
      }
    } catch (err) {
      console.error(err);
      setIsSubmit(false);
    }
  };

  const closeAskSubmit = async () => {
    setIsOpenAskingWhyFindCrew(false);
    submit();
  };

  const submitOrAsk = async () => {
    if(jobPost?.auto_created_when_sign_up) {
      setIsOpenAskingWhyFindCrew(true);
    } else {
      submit();
    }
  };

  const closeAndNext = async () => {
    setIsDIOManagerCallDialogOpen(false);
    await toggleDialog(jobPost.id);
  };

  return (
    <Paper sx={{ mb: 10 }}>
      <Stack sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          📨 심사 전, 마지막으로 작성하신 내용을 확인해주세요.
        </Typography>
        <Typography variant="body2" sx={{ ...!smUp && { color: 'text.secondary' } }}>
          제출하시면 <DIOText />에서 공고를 검토 후 연락드립니다.
        </Typography>
      </Stack>

      <JobPostDoneCard jobPost={jobPost} blueLabel={true} />

      <DIOManagerCallDialog open={isDIOManagerCallDialogOpen} closeDialog={closeAndNext} />

      <Stack spacing={2} direction="row" sx={{ mt: 3 }}>
        <LoadingButton
          variant="contained"
          size="large"
          fullWidth
          onClick={submitOrAsk}
          loading={isSubmit}
        >
          제출하기
        </LoadingButton>
      </Stack>

      <AskingWhyFindCrewDialog
        isOpen={isOpenAskingWhyFindCrew}
        closeDialog={() => closeAskSubmit()}
        submit={() => closeAskSubmit()}
      />
    </Paper>
  )
}